import { Component, OnInit, inject, TemplateRef, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CustomHttpService } from "../../services/custom-http.service";
import { formatDateToTIMEDATE, formatDateToYYYYMM } from "../../service/global.service";
import { AlertsService } from "../../services/alerts.service";
import { AuthService } from "../../services/accounts/auth.service";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { timer } from 'rxjs';
import { toZonedTime } from 'date-fns-tz';
import * as moment from 'moment-timezone';
import { ActivatedRoute, Router } from '@angular/router';
import { TripStateServiceService } from 'src/app/services/trip-state-service.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-tripapprovals',
  templateUrl: './tripapprovals.component.html',
  styleUrls: ['./tripapprovals.component.css']
})
export class TripapprovalsComponent implements OnInit {
   @ViewChild('hotelRateModal') hotelRateModal!: TemplateRef<any>;

  constructor(
    public custom: CustomHttpService,
    public alertService: AlertsService,
    public auth: AuthService,
    private route: ActivatedRoute,
    private tripStateService: TripStateServiceService,
    public router: Router,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer
  ) { }

  // private modalService = inject(NgbModal);
  private modalRef!: NgbModalRef; // store reference to modal
  newHotelPrice: string = '';
  priceChangeDetected: boolean = false;
  trips: any[] = [];
  carRentals: any[] = [];
  hotels: any[] = [];
  allTrips: any[] = [];
  isTripsloaded: boolean = true;
  loader: boolean = false;
  newData: any = { type: 'department', name: '', company_id: '', manager_id: '' };
  rejectData: any = { reason: '' }
  approveOutOfPolicyData: any = { reason: '' }
  approvalStages: any = 0;
  totalNumberOfPendingApprovals = 0;
  totalAmountOfPendingApprovals = 0;
  totalAmountOfApprovals = 0;
  selectedTrip: any = {};
  authToken: string = '';
  hotelRoomRateComment: string = '';
  notes: SafeHtml = '';

  redirectedTicketId: any = '';
  redirect: string|null = '';
  activeTab: string = 'hotels'; // Default tab

  filterOpen = false;
  filters = { status: '', minAmount: null as number | null, maxAmount: null as number | null, travelDate: '' };

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.trips-filter-wrapper')) this.filterOpen = false;
  }

  private getItemAmount(trip: any, tab: string): number {
    if (tab === 'pending') return parseFloat(trip.booking_request?.booking_details?.outbound?.trip_details?.total_amount || 0);
    if (tab === 'car-hire') return parseFloat(trip.booking_request?.booking_details?.outbound?.trip_details?.estimated_cost || 0);
    if (tab === 'hotels') return parseFloat(trip.booking_request?.booking_details?.total_price || 0);
    return 0;
  }

  private getItemDate(trip: any, tab: string): string {
    if (tab === 'pending') return trip.booking_request?.booking_details?.outbound?.trip_details?.slices?.[0]?.departing_day || '';
    if (tab === 'car-hire') return trip.booking_request?.booking_details?.outbound?.trip_details?.hire_start_date || '';
    if (tab === 'hotels') return trip.booking_request?.booking_details?.checkin || '';
    return '';
  }

  private filterItems(items: any[], tab: string): any[] {
    let result = [...items];
    const tabMax = items.reduce((m, t) => Math.max(m, this.getItemAmount(t, tab)), 0);

    if (this.filters.status) {
      result = result.filter(t => (t.status || '').toUpperCase() === this.filters.status);
    }
    if (this.filters.minAmount != null && this.filters.minAmount > 0) {
      result = result.filter(t => this.getItemAmount(t, tab) >= this.filters.minAmount!);
    }
    if (this.filters.maxAmount != null && this.filters.maxAmount < tabMax) {
      result = result.filter(t => this.getItemAmount(t, tab) <= this.filters.maxAmount!);
    }
    if (this.filters.travelDate) {
      const from = new Date(this.filters.travelDate);
      result = result.filter(t => {
        const d = this.getItemDate(t, tab);
        return d ? new Date(d) >= from : false;
      });
    }
    return result;
  }

  get filteredFlights(): any[] { return this.filterItems(this.trips, 'pending'); }
  get filteredCarRentals(): any[] { return this.filterItems(this.carRentals, 'car-hire'); }
  get filteredHotels(): any[] { return this.filterItems(this.hotels, 'hotels'); }

  get maxCurrentTabAmount(): number {
    if (this.activeTab === 'pending') return this.trips.reduce((m, t) => Math.max(m, this.getItemAmount(t, 'pending')), 0);
    if (this.activeTab === 'car-hire') return this.carRentals.reduce((m, t) => Math.max(m, this.getItemAmount(t, 'car-hire')), 0);
    if (this.activeTab === 'hotels') return this.hotels.reduce((m, t) => Math.max(m, this.getItemAmount(t, 'hotels')), 0);
    return 0;
  }

  get hasActiveFilters(): boolean {
    const minActive = this.filters.minAmount != null && this.filters.minAmount > 0;
    const maxActive = this.filters.maxAmount != null && this.filters.maxAmount < this.maxCurrentTabAmount;
    return !!(this.filters.status || minActive || maxActive || this.filters.travelDate);
  }

  applyFilters() { this.filterOpen = false; }

  resetFilters() {
    this.filters = { status: '', minAmount: null, maxAmount: null, travelDate: '' };
    this.filterOpen = false;
  }

  isAdmin = false;
  isRejectTripModal = '';
  isApproveOutOfPolicyModal = ''
  errorStageMessage = '';
  rejectTrip = { 
    isLoading: false, 
    isRejectLoading: false,
    id: '',
    booking_request: {
      id: ''
    }
  }

  approveOutOfPolicyTrip = { 
    isLoading: false, 
    isApproveOutOfPolicyLoading: false,
    id: '',
    booking_request: {
      id: ''
    }
  }

  // openModal(content: any) {
  //   this.modalService.open(content);
  // }

  // closeModal(modal: any) {
  //   modal.close(); // This will properly close and remove backdrop
  // }

  ngOnInit() {
    this.redirectedTicketId = this.tripStateService.getTicketId()
    console.log('ticket id', this.redirectedTicketId);
    this.redirect = this.tripStateService.getRedirectVal()
    console.log('approver', this.redirect);
    const isAuth = this.auth.isAuthenticated()
    this.authToken = `Bearer ${this.auth.getToken()}`;
    console.log('is auth', isAuth);

    if (!this.redirect) {
      this.route.paramMap.subscribe(params => {
        // Extract the trip ID from the URL
        this.redirectedTicketId = params.get('id');
        this.tripStateService.setTicketId(this.redirectedTicketId)
        console.log('Ticket ID:', this.redirectedTicketId);
      });
      // console.log('Ticket ID:', this.redirectedTicketId);
      this.route.queryParamMap.subscribe(queryParams => {
        this.redirect = queryParams.get('redirect');
        this.tripStateService.setRedirectName(this.redirect)
        console.log('Redirect:', this.redirect);
        if(!isAuth){
          this.router.navigate(['/accounts'])
        } else {
          if (this.activeTab == 'hotels') {
            this.getPendingHotelApprovals();
          } else {
            this.getPendingApprovals();
            this.getPendingCarApprovals();
            this.getTrips();
          }
          // this.fetchApprovalStages();
          if (this.redirect === 'approver') {
            this.activeTab = 'pending'
          } else if (this.redirect === 'traveller'){
            this.activeTab = 'upcoming'
          } else if (this.redirect === 'car-approval'){
            this.activeTab = 'car-hire'
          } else if (this.redirect === 'hotels'){
            this.activeTab = 'hotels' 
          } else {
            
          }
        }
      });
    } else {
      if(!isAuth){
        this.router.navigate(['/accounts'])
      } else {
        this.getPendingApprovals();
        this.getPendingCarApprovals();
        this.getPendingHotelApprovals();
        this.getTrips()
        // this.fetchApprovalStages();
      }
    }
 
    // console.log('Redirect:', this.redirect);

    // this.auth.isAuthenticatedSubject.subscribe((value) => {
    //   console.log('Ticket ID:', this.tripStateService.getTicketId());
    //   console.log('Redirect:', this.redirect);
    //   if(value){
    //     this.router.navigate(['/accounts'], {
    //       queryParams: {
    //         redirectFromApproval: 'hjjj-ggg-hhh',
    //         ticketId: 'approver'
    //       }
    //     })
    //   } else {
    //     this.getPendingApprovals();
    //     this.getTrips()
    //     this.fetchApprovalStages();
    //   }
    // });
    if (this.auth.user().is_superuser) {
      // console.log('user', this.auth.user().is_superuser)
      this.isAdmin = this.auth.user().is_superuser
    }
  }

  switchTab(tab: string) {
    if (this.activeTab !== tab) {
      this.filters = { status: '', minAmount: null, maxAmount: null, travelDate: '' };
      this.filterOpen = false;
    }
    this.activeTab = tab;
    if (tab === 'hotels' && !this.hotels.length){
      this.getPendingHotelApprovals();
    } else if (tab === 'car-hire' && !this.carRentals.length) {
      this.getPendingCarApprovals();
    } else if (tab === 'pending' && !this.trips.length){
      this.getPendingApprovals();
    }
  }

  handleTripModal(content: any ,trip: any) {
    this.modalService.open(content);
    console.log('selected trip', trip)
    this.selectedTrip = trip
  }

  handleHotelModal(content: any ,trip: any) {
    this.modalService.open(content);
    console.log('selected hotel', trip)
    this.selectedTrip = trip
  }

  handleCarModal(content: any ,trip: any) {
    this.modalService.open(content);
    console.log('selected car rental', trip)
    this.selectedTrip = trip
  }

  downloadPDF(elementId: string, channel: string) {
    let ticketId = ''
    if (channel === 'flights') {
      ticketId = 'flight_ticket'+elementId
    } else {
      ticketId = 'bus_ticket'+elementId
    }
    const element = document.getElementById(ticketId);

    if (!element) {
      console.error('Element not found!');
      return;
    }
    element.style.display = 'block';
    html2canvas(element, { 
      scale: 2,
      useCORS: true, // Enable CORS for external images
      allowTaint: true, // Allows cross-origin images
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/jpeg');
      const pdf = new jsPDF('p', 'mm', 'a4');

      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
      pdf.save('ticket.pdf');
      element.style.display = 'none';
    });
  }

  // Toggle loader
  isToggleLoader() {
    this.loader = !this.loader;
  }

  // Fetch trips and initialize timers
  getTrips() {
    this.isToggleLoader();
    this.allTrips = [];
    this.custom.getTrips().subscribe(
      (data) => {
        this.resetTotals();
        this.allTrips = data.map(trip => ({
          ...trip,
          isLoading: false,
          isRejectLoading: false,
          remainingTime: this.calculateRemainingTime(trip),
          minutes: 0,
          seconds: 0,
          timer: null
        }));
        console.log('trips', this.allTrips)
        this.updateApprovalStats();
        this.initializeTimers();
        this.isToggleLoader();
      },
      () => this.isToggleLoader()
    );
  }

  openRejectModal(trip: any){
    console.log('reject modal', trip)
    this.rejectTrip = {
      ...this.rejectTrip,
      ...trip
    }
    this.isRejectTripModal = trip.booking_request.id 
  }

  openOutOfPolicyModal(trip: any){
    console.log('approve modal', trip)
    this.approveOutOfPolicyTrip = {
      ...this.approveOutOfPolicyTrip,
      ...trip
    }
    this.isApproveOutOfPolicyModal = trip.booking_request.id 
  }

  closeRejectModal(){
    this.isRejectTripModal = '';
    this.isApproveOutOfPolicyModal = '';
  }

  getPendingHotelApprovals(){
    this.isToggleLoader();
    this.trips = [];
    this.custom.getPendingApprovalsV2('hotels').subscribe(
      (data) => {
        this.resetTotals();
        // this.trips = data.map(trip => ({
        //   ...trip,
        //   isLoading: false,
        //   isRejectLoading: false,
        //   remainingTime: this.calculateRemainingTime(trip),
        //   minutes: 0,
        //   seconds: 0,
        //   timer: null
        // }));

        console.log('hotels approvals pending', data)
        this.hotels = data

        // this.trips = []
        this.updateApprovalStats();
        this.initializeTimers();
        this.isToggleLoader();
      },
      () => this.isToggleLoader()
    );
  }
  getPendingApprovals(){
    this.isToggleLoader();
    this.trips = [];
    this.custom.getPendingApprovalsV2('flights').subscribe(
      (data) => {
        this.resetTotals();
        this.trips = data.map(trip => ({
          ...trip,
          isLoading: false,
          isRejectLoading: false,
          remainingTime: this.calculateRemainingTime(trip),
          minutes: 0,
          seconds: 0,
          timer: null
        }));

        //console.log('approvals pending', data)
        this.trips = this.trips

        // this.trips = []
        this.updateApprovalStats();
        this.initializeTimers();
        this.isToggleLoader();
      },
      () => this.isToggleLoader()
    );
  }

  getPendingCarApprovals(){
    this.isToggleLoader();
    this.trips = [];
    this.custom.getPendingApprovalsV2('car-hire').subscribe(
      (data) => {
        this.resetTotals();
        // this.trips = data.map(trip => ({
        //   ...trip,
        //   isLoading: false,
        //   isRejectLoading: false,
        //   remainingTime: this.calculateRemainingTime(trip),
        //   minutes: 0,
        //   seconds: 0,
        //   timer: null
        // }));

        // console.log('car hire approvals pending', data)
        this.carRentals = data

        // this.trips = []
        this.updateApprovalStats();
        this.initializeTimers();
        this.isToggleLoader();
      },
      () => this.isToggleLoader()
    );
  }

  fetchApprovalStages(): void {
    this.custom.getApprovalStages(this.auth.getUserCompanyId()).subscribe(
      (stages: any[]) => {
        this.approvalStages = stages.length;
      },
      (error) => {
        console.error('Error fetching approval stages:', error);
       
      }
    );
  }
  // Reset totals for recalculation
  resetTotals() {
    this.totalNumberOfPendingApprovals = 0;
    this.totalAmountOfPendingApprovals = 0;
    this.totalAmountOfApprovals = 0;
  }

  // Update stats for pending and approved trips
  updateApprovalStats() {
    this.trips.forEach(trip => {
      if (trip.booking_status === 'Pending Approval') {
        this.totalNumberOfPendingApprovals++;
        this.totalAmountOfPendingApprovals += parseFloat(trip.booking_details.payments.amount);
      } else if (trip.booking_status === 'Approved') {
        this.totalAmountOfApprovals += parseFloat(trip.booking_details.payments.amount);
      }
    });
  }

  // Initialize timers for trips
  initializeTimers() {
    this.trips.forEach(trip => {
      if (trip.remainingTime > 0) {
        this.startTripCountdown(trip);
      }
    });
  }

  // Calculate remaining time in milliseconds
  calculateRemainingTime(trip: any): number {
    const expiresAtUTC = trip.booking_details?.tripDetails?.expires_at;
  
    if (!expiresAtUTC) return 0;
  
    // Convert the UTC expiration time to EAT (Africa/Nairobi)
    const expiresAtLocal = moment.utc(expiresAtUTC).local().valueOf();
  
    // Get the current time in EAT for accurate comparison
    const currentTimeLocal = moment().local().valueOf();
  
    console.log(`Expires At (Local): ${expiresAtLocal}, Current Time (Local): ${currentTimeLocal}`);
  
    return Math.max(0, expiresAtLocal - currentTimeLocal);
  }
  
  // Start countdown timer
  startTimersForTrips() {
    this.trips.forEach(trip => {
      if (trip.timer) {
        clearInterval(trip.timer); // Clear any previous timer
      }
      if (trip.remainingTime > 0) {
        this.startTripCountdown(trip);
      }
    });
  }
  
  startTripCountdown(trip: any) {
    trip.timer = setInterval(() => {
      if (trip.remainingTime > 0) {
        trip.remainingTime -= 1000;
        trip.minutes = Math.floor(trip.remainingTime / 1000 / 60);
        trip.seconds = Math.floor((trip.remainingTime / 1000) % 60);
      } else {
        clearInterval(trip.timer);
        trip.remainingTime = 0;
        trip.timer = null;
      }
    }, 1000);
  }
  
  hideModal(modal: any){
    modal.close()
  }

  private decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  // Approve a trip
  approve(modal: any,trip: any) {
    const data = { status: "APPROVED", reason: "" };
    console.log('trip', trip);
    console.log('this.selectedTrip hotel', this.selectedTrip);
    trip.isLoading = true;
  
    this.custom.approveV2(trip.id, data, this.authToken).subscribe(
      (res: any) => {
        trip.isLoading = false;
        modal.close(); // This will properly close and remove backdrop
        // this.getPendingApprovals(); // Reload trips to get updated expires_at
        // this.getPendingCarApprovals();

        if (this.selectedTrip.booking_request.channels == 'hotels') {

          if ((this.selectedTrip.approval_stage_sequence === this.selectedTrip.approval_total_stages)) {
            console.log('rate', res);
            //this.modalService.open(hotelRateModal);
            this.modalRef = this.modalService.open(this.hotelRateModal, {});
            this.hotelRoomRateComment = res?.data?.rooms[0]?.rate_comments;
            try {
              // Step 1: Replace escaped quotes and parse as JSON array
              const cleaned = this.hotelRoomRateComment.replace(/^\{|\}$/g, '').replace(/\\"/g, '"');
              const jsonLike = `[${cleaned}]`;
              const arr = JSON.parse(jsonLike);

              // Step 2: Join and decode HTML
              const decodedHtml = arr.map((x: string) => this.decodeHtml(x)).join('<br/><br/>');

              // Step 3: Sanitize for Angular
              this.notes = this.sanitizer.bypassSecurityTrustHtml(decodedHtml);
            } catch (e) {
              console.error('Failed to parse hotel notes', e);
            } 
          } else {
           this.alertService.showSuccess("Hotel reservation approved successfully");
           this.getPendingHotelApprovals(); 
          }
        } else {
          this.alertService.showSuccess("Trip Approved Successfully");
          this.getPendingApprovals(); // Reload trips to get updated expires_at
          this.getPendingCarApprovals();
          this.getPendingHotelApprovals()
        }
      },
      (err) => {
        trip.isLoading = false;
        modal.close(); // This will properly close and remove backdrop
        if (this.activeTab == 'hotels') {
          console.log('hotels error', err)
          this.alertService.showError(err.error.error.message);
          this.getPendingHotelApprovals();
        } else {
          this.alertService.showError("Trip Approval Failed");
        } 
        // this.alertService.showError("Trip Approval Failed");
      }
    );
  }


    // Approve a trip
  approveHotel(modal: any,trip: any) {
    const data = { status: "APPROVED", reason: "" };
    console.log('trip', trip);
    console.log('this.selectedTrip hotel', this.selectedTrip);
    trip.isLoading = true;
  
    this.custom.approveV2(trip.id, data, this.authToken).subscribe(
      (res: any) => {
        trip.isLoading = false;
        modal.close(); // This will properly close and remove backdrop
        // this.getPendingApprovals(); // Reload trips to get updated expires_at
        // this.getPendingCarApprovals();

        if (this.selectedTrip.booking_request.channels == 'hotels') {

          if ((this.selectedTrip.approval_stage_sequence === this.selectedTrip.approval_total_stages)) {
            console.log('rate', res);
            //this.modalService.open(hotelRateModal);
            this.modalRef = this.modalService.open(this.hotelRateModal, {});

            if (res.data.price_change_detected) {
              this.priceChangeDetected = true
              this.newHotelPrice = res.data.currency + ' ' + res.data.new_total_price
            }

            if (res?.data?.rooms[0]?.rate_comments[0] === '.') {
              this.notes = res?.data?.rooms[0]?.rate_comments;
              
            } else {
              this.hotelRoomRateComment = res?.data?.rooms[0]?.rate_comments;
              try {
                // // Step 1: Replace escaped quotes and parse as JSON array
                // const cleaned = this.hotelRoomRateComment.replace(/^\{|\}$/g, '').replace(/\\"/g, '"');
                // const jsonLike = `[${cleaned}]`;
                // const arr = JSON.parse(jsonLike);

                // // Step 2: Join and decode HTML
                // const decodedHtml = arr.map((x: string) => this.decodeHtml(x)).join('<br/><br/>');

                // // Step 3: Sanitize for Angular
                // this.notes = this.sanitizer.bypassSecurityTrustHtml(decodedHtml);
                this.notes = this.hotelRoomRateComment;
              } catch (e) {
                console.error('Failed to parse hotel notes', e);
              } 
            }
          } else {
           this.alertService.showSuccess("Hotel reservation approved successfully");
           this.getPendingHotelApprovals(); 
          }
        } else {
          this.alertService.showSuccess("Trip Approved Successfully");
          this.getPendingApprovals(); // Reload trips to get updated expires_at
          this.getPendingCarApprovals();
          this.getPendingHotelApprovals()
        }
      },
      (err) => {
        trip.isLoading = false;
        modal.close(); // This will properly close and remove backdrop
        if (this.activeTab == 'hotels') {
          console.log('hotels error', err)
          this.alertService.showError(err.error.error.message);
          this.getPendingHotelApprovals();
        } else {
          this.alertService.showError("Trip Approval Failed");
        } 
        // this.alertService.showError("Trip Approval Failed");
      }
    );
  }
  
  approveOutOfPolicyHotel(modal: any,trip: any) {
    const data = { status: "APPROVED", reason: this.approveOutOfPolicyData.reason };
    console.log('trip', trip);
    console.log('this.selectedTrip hotel', this.selectedTrip);
    trip.isLoading = true;
  
    this.custom.approveV2(trip.id, data, this.authToken).subscribe(
      (res: any) => {
        trip.isLoading = false;
        modal.close(); // This will properly close and remove backdrop
        // this.getPendingApprovals(); // Reload trips to get updated expires_at
        // this.getPendingCarApprovals();

        if (this.selectedTrip.booking_request.channels == 'hotels') {

          if ((this.selectedTrip.approval_stage_sequence === this.selectedTrip.approval_total_stages)) {
            console.log('rate', res);
            //this.modalService.open(hotelRateModal);
            this.modalRef = this.modalService.open(this.hotelRateModal, {});

            if (res.data.price_change_detected) {
              this.priceChangeDetected = true
              this.newHotelPrice = res.data.currency + ' ' + res.data.new_total_price
            }

            if (res?.data?.rooms[0]?.rate_comments[0] === '.') {
              this.notes = res?.data?.rooms[0]?.rate_comments;
              
            } else {
              this.hotelRoomRateComment = res?.data?.rooms[0]?.rate_comments;
              try {
                // // Step 1: Replace escaped quotes and parse as JSON array
                // const cleaned = this.hotelRoomRateComment.replace(/^\{|\}$/g, '').replace(/\\"/g, '"');
                // const jsonLike = `[${cleaned}]`;
                // const arr = JSON.parse(jsonLike);

                // // Step 2: Join and decode HTML
                // const decodedHtml = arr.map((x: string) => this.decodeHtml(x)).join('<br/><br/>');

                // // Step 3: Sanitize for Angular
                // this.notes = this.sanitizer.bypassSecurityTrustHtml(decodedHtml);
                this.notes = this.hotelRoomRateComment;
              } catch (e) {
                console.error('Failed to parse hotel notes', e);
              } 
            }
          } else {
           this.alertService.showSuccess("Hotel reservation approved successfully");
           this.getPendingHotelApprovals(); 
          }
        } else {
          this.alertService.showSuccess("Trip Approved Successfully");
          this.getPendingApprovals(); // Reload trips to get updated expires_at
          this.getPendingCarApprovals();
          this.getPendingHotelApprovals()
        }
      },
      (err) => {
        trip.isLoading = false;
        modal.close(); // This will properly close and remove backdrop
        if (this.activeTab == 'hotels') {
          console.log('hotels error', err)
          this.alertService.showError(err.error.error.message);
          this.getPendingHotelApprovals();
        } else {
          this.alertService.showError("Trip Approval Failed");
        } 
        // this.alertService.showError("Trip Approval Failed");
      }
    );
  }
    // Approve a trip
  completeApproval(modal: any,trip: any) {
    const data = { status: "APPROVED", reason: "" };
    console.log('trip hotels', trip);
    console.log('this.selectedTrip hotel', this.selectedTrip);
    trip.isLoading = true;
    let consentPayload = {};
    if (this.priceChangeDetected) {
      consentPayload = {user_consent: true}
    } else {
      consentPayload = {}
    }
  
    this.custom.completeApprovalV2(trip.booking_request.id, consentPayload , this.authToken).subscribe(
      (res: any) => {
        //this.alertService.showSuccess("Trip Approved Successfully");
        trip.isLoading = false;
        modal.close(); // This will properly close and remove backdrop
        // this.getPendingApprovals(); // Reload trips to get updated expires_at
        // this.getPendingCarApprovals();

  
        if ((this.selectedTrip.approval_stage_sequence === this.selectedTrip.approval_total_stages)) {
          console.log('rate', res);
          //this.modalService.open(hotelRateModal);
          //this.modalService.open(this.hotelRateModal, {});
          if (this.modalRef) {
            this.modalRef.close(); // or .dismiss()
          }
          this.hotelRoomRateComment = res?.data?.rooms[0]?.rate_comments;
          this.alertService.showSuccess('Hotel room reservation approved');
          this.hotels = [];
          this.getPendingHotelApprovals(); 
        } else {
          this.hotels = [];
          this.getPendingHotelApprovals(); 
        }
        
      },
      (err) => {
        trip.isLoading = false;
        modal.close(); // This will properly close and remove backdrop
        if (this.activeTab == 'hotels') {
          console.log('hotels error', err)
          this.alertService.showError(err?.error?.error?.message ? err.error.error.message: 'The Approval Could Not Be Completed' );
          this.getPendingHotelApprovals();
        } else {
          this.alertService.showError("Trip Approval Failed");
        } 
        // this.alertService.showError("Trip Approval Failed");
      }
    );
  }

  // Reject a trip
  reject(modal: any) {
    console.log('reject body', this.rejectTrip)
    const data = { status: "REJECTED", reason: this.rejectData.reason };
    if (!this.rejectData.reason) {
      this.errorStageMessage = 'Enter a reason for rejection'
      setTimeout(() => {
        this.errorStageMessage = ''
      }, 5000);
      return;
    }
    this.rejectTrip.isRejectLoading = true;
    this.custom.approveV2(this.rejectTrip.id, data, this.authToken).subscribe(
      () => {
        modal.close()
        this.alertService.showSuccess("Trip Rejected Successfully");
        this.getPendingApprovals();
        this.getPendingCarApprovals();
        this.getPendingHotelApprovals()
        this.isRejectTripModal = '';
        this.rejectTrip.isRejectLoading = false;
      },
      () => {
        modal.close()
        this.rejectTrip.isRejectLoading = false;
        this.isRejectTripModal = ''
        this.alertService.showError("Trip Rejection Failed");
      }
    );
  }

  decline() {

  }

  protected readonly formatDateToYYYYMM = formatDateToYYYYMM;
  protected readonly formatDateToTIMEDATE = formatDateToTIMEDATE;
}
